export default {
    pdl: '',
};
